import { globalConstants, recruiterConstants } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  data: [],
  allData: [],
  formData: {},
  assignedProjects:[],
  isManager: false
};
//Manipulating the state of admin portal based on actions and returning the state
export const recruiterReducer = (state = initialState, action) => {
  switch (action.type) {
    case recruiterConstants.GET_RECRUITERS + SUCCESS:
      return { ...state, data: action.data };
    case recruiterConstants.GET_RECRUITER_LIST + SUCCESS:
      return { ...state, allData: action.data };
    case recruiterConstants.GET_RECRUITER_BY_ID + SUCCESS:
      return { ...state, formData: action.data };
    case recruiterConstants.GET_RECRUITER_ASSIGNED_PROJECTS + SUCCESS:
      return { ...state, assignedProjects: action.data };
    case recruiterConstants.IS_MANAGER + SUCCESS:
      return { ...state, isManager: action.data };
    default:
      return state;
  }
};
